import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/es"; // Configurar moment en español

moment.locale("es"); // Configurar locale para react-datepicker (usando moment directamente)
// react-datepicker usa moment internamente, así que con moment.locale("es") debería funcionar

var CONTRACT_TYPES = [{
  value: "Honorarios",
  label: "Honorarios"
}, {
  value: "Fijo",
  label: "Fijo"
}, {
  value: "Indefinido",
  label: "Indefinido"
}]; // Función helper para calcular edad

var calculateAge = function calculateAge(birthdate) {
  if (!birthdate) return null;
  var age = moment().diff(moment(birthdate), "years");
  return age;
};

var UserForm = function UserForm(props) {
  var adminJson = props.admin,
      token = props.token,
      isNew = props.isNew;
  var initialAdmin = JSON.parse(adminJson); // Clave única para localStorage (memoizada para evitar cambios)

  var storageKey = React.useMemo(function () {
    return isNew ? "admin_form_draft_new" : "admin_form_draft_".concat(initialAdmin.id);
  }, [isNew, initialAdmin.id]); // Cargar datos guardados del localStorage al iniciar

  var savedData = React.useMemo(function () {
    try {
      var saved = localStorage.getItem(storageKey);

      if (saved) {
        var parsed = JSON.parse(saved);
        return parsed;
      }
    } catch (e) {// Error al cargar datos guardados
    }

    return null;
  }, [storageKey]);
  var initialFormData = (savedData === null || savedData === void 0 ? void 0 : savedData.formData) || initialAdmin;
  var initialPassword = (savedData === null || savedData === void 0 ? void 0 : savedData.password) || "";
  var initialPasswordConfirmation = (savedData === null || savedData === void 0 ? void 0 : savedData.passwordConfirmation) || "";
  var initialLifeCommission = (savedData === null || savedData === void 0 ? void 0 : savedData.lifeCommissionInput) || (initialFormData.life_commission !== undefined && initialFormData.life_commission !== null ? initialFormData.life_commission.toString().replace(".", ",") : "");
  var initialGeneralCommission = (savedData === null || savedData === void 0 ? void 0 : savedData.generalCommissionInput) || (initialFormData.general_commission_percentage !== undefined && initialFormData.general_commission_percentage !== null ? initialFormData.general_commission_percentage.toString().replace(".", ",") : "");
  var initialRenewalCommission = (savedData === null || savedData === void 0 ? void 0 : savedData.renewalCommissionInput) || (initialFormData.renewal_commission !== undefined && initialFormData.renewal_commission !== null ? initialFormData.renewal_commission.toString().replace(".", ",") : "");

  var _React$useState = React.useState(initialFormData),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      formData = _React$useState2[0],
      setFormData = _React$useState2[1];

  var _React$useState3 = React.useState(initialPassword),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      password = _React$useState4[0],
      setPassword = _React$useState4[1];

  var _React$useState5 = React.useState(initialPasswordConfirmation),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      passwordConfirmation = _React$useState6[0],
      setPasswordConfirmation = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      showPassword = _React$useState8[0],
      setShowPassword = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      showPasswordConfirmation = _React$useState10[0],
      setShowPasswordConfirmation = _React$useState10[1];

  var _React$useState11 = React.useState([]),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      errors = _React$useState12[0],
      setErrors = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      isSubmitting = _React$useState14[0],
      setIsSubmitting = _React$useState14[1];

  var _React$useState15 = React.useState(""),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      successMessage = _React$useState16[0],
      setSuccessMessage = _React$useState16[1]; // Estados locales para los campos de comisión (para permitir escribir comas/puntos)


  var _React$useState17 = React.useState(initialLifeCommission),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      lifeCommissionInput = _React$useState18[0],
      setLifeCommissionInput = _React$useState18[1];

  var _React$useState19 = React.useState(initialGeneralCommission),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      generalCommissionInput = _React$useState20[0],
      setGeneralCommissionInput = _React$useState20[1];

  var _React$useState21 = React.useState(initialRenewalCommission),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      renewalCommissionInput = _React$useState22[0],
      setRenewalCommissionInput = _React$useState22[1]; // Estado para edad editable


  var calculatedAge = calculateAge(initialFormData.birthdate || "");

  var _React$useState23 = React.useState(calculatedAge !== null ? calculatedAge.toString() : ""),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      ageInput = _React$useState24[0],
      setAgeInput = _React$useState24[1]; // Guardar datos en localStorage cuando cambien


  React.useEffect(function () {
    try {
      var dataToSave = {
        formData: formData,
        password: password,
        passwordConfirmation: passwordConfirmation,
        lifeCommissionInput: lifeCommissionInput,
        generalCommissionInput: generalCommissionInput,
        renewalCommissionInput: renewalCommissionInput,
        ageInput: ageInput
      };
      localStorage.setItem(storageKey, JSON.stringify(dataToSave));
    } catch (e) {// Error al guardar datos
    }
  }, [formData, password, passwordConfirmation, lifeCommissionInput, generalCommissionInput, renewalCommissionInput, ageInput, storageKey]); // Actualizar edad cuando cambie la fecha de nacimiento

  React.useEffect(function () {
    var newAge = calculateAge(formData.birthdate || "");

    if (newAge !== null) {
      setAgeInput(newAge.toString());
    } else {
      setAgeInput("");
    }
  }, [formData.birthdate]);

  var handleChange = function handleChange(field, value) {
    setFormData(_objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, field, value)));
  };

  var handleClearForm = function handleClearForm() {
    if (window.confirm("¿Está seguro que desea limpiar todos los campos del formulario?")) {
      var emptyAdmin = {
        email: "",
        full_name: "",
        rut: "",
        position: "",
        contract_start_date: undefined,
        contract_end_date: undefined,
        contract_type: "",
        birthdate: undefined,
        phone: "",
        life_commission: undefined,
        general_commission_percentage: undefined,
        renewal_commission: undefined,
        comments: ""
      };
      setFormData(emptyAdmin);
      setPassword("");
      setPasswordConfirmation("");
      setLifeCommissionInput("");
      setGeneralCommissionInput("");
      setRenewalCommissionInput("");
      setAgeInput("");
      setErrors([]); // Limpiar localStorage

      try {
        localStorage.removeItem(storageKey);
      } catch (e) {// Error al limpiar datos guardados
      }
    }
  };

  var handleDateChange = function handleDateChange(field, date) {
    if (date) {
      var dateStr = moment(date).format("YYYY-MM-DD");
      handleChange(field, dateStr); // Si cambia la fecha de nacimiento, actualizar la edad calculada

      if (field === "birthdate") {
        var newAge = calculateAge(dateStr);

        if (newAge !== null) {
          setAgeInput(newAge.toString());
        } else {
          setAgeInput("");
        }
      }
    } else {
      handleChange(field, null);

      if (field === "birthdate") {
        setAgeInput("");
      }
    }
  };

  var formatDate = function formatDate(date) {
    if (!date) return "-";
    return moment(date).format("DD/MM/YYYY");
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var submitData, url, method, response, data, _data, errorMessage;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setIsSubmitting(true);
              setErrors([]); // Validar que contratos "Fijo" tengan fecha fin

              if (!(formData.contract_type === "Fijo" && !formData.contract_end_date)) {
                _context.next = 7;
                break;
              }

              setErrors(["Los contratos fijos requieren una fecha de finalización"]);
              setIsSubmitting(false);
              return _context.abrupt("return");

            case 7:
              if (!(isNew && password && password !== passwordConfirmation)) {
                _context.next = 11;
                break;
              }

              setErrors(["Las contraseñas no coinciden"]);
              setIsSubmitting(false);
              return _context.abrupt("return");

            case 11:
              if (!(!isNew && password && password !== passwordConfirmation)) {
                _context.next = 15;
                break;
              }

              setErrors(["Las contraseñas no coinciden"]);
              setIsSubmitting(false);
              return _context.abrupt("return");

            case 15:
              submitData = _objectSpread(_objectSpread({}, formData), {}, {
                authenticity_token: token
              });

              if (isNew && password) {
                submitData.password = password;
                submitData.password_confirmation = passwordConfirmation;
              } else if (!isNew && password) {
                submitData.password = password;
                submitData.password_confirmation = passwordConfirmation;
              }

              _context.prev = 17;
              url = isNew ? "/api/v1/administrators" : "/api/v1/administrators/".concat(formData.id);
              method = isNew ? "POST" : "PATCH";
              _context.next = 22;
              return fetch(url, {
                method: method,
                headers: {
                  "Content-Type": "application/json",
                  "X-CSRF-Token": token
                },
                body: JSON.stringify({
                  admin: submitData
                })
              });

            case 22:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 33;
                break;
              }

              _context.next = 26;
              return response.json();

            case 26:
              data = _context.sent;

              // Limpiar datos guardados del localStorage al guardar exitosamente
              try {
                localStorage.removeItem(storageKey);
              } catch (e) {// Error al limpiar datos guardados
              }

              setSuccessMessage(isNew ? "Ejecutivo creado correctamente" : "Ejecutivo actualizado correctamente");
              setIsSubmitting(false); // Redirigir después de mostrar el mensaje de éxito a la vista del ejecutivo

              setTimeout(function () {
                var adminId = isNew ? data.id : formData.id;
                window.location.href = "/admin/administrators/".concat(adminId);
              }, 1500);
              _context.next = 44;
              break;

            case 33:
              _context.prev = 33;
              _context.next = 36;
              return response.json();

            case 36:
              _data = _context.sent;
              setErrors(_data.errors || ["Error al guardar (".concat(response.status, ")")]);
              _context.next = 43;
              break;

            case 40:
              _context.prev = 40;
              _context.t0 = _context["catch"](33);
              // Si no se puede parsear la respuesta, mostrar error genérico
              setErrors(["Error al guardar. C\xF3digo de respuesta: ".concat(response.status)]);

            case 43:
              setIsSubmitting(false);

            case 44:
              _context.next = 52;
              break;

            case 46:
              _context.prev = 46;
              _context.t1 = _context["catch"](17);
              // Detectar el tipo de error
              errorMessage = "Error de conexión. Por favor, verifica tu conexión a internet e intenta nuevamente.";

              if (_context.t1 instanceof TypeError && _context.t1.message.includes("fetch")) {
                errorMessage = "No se pudo conectar con el servidor. Verifica tu conexión a internet.";
              } else if (_context.t1.name === "NetworkError" || _context.t1.message === "Network request failed") {
                errorMessage = "Error de red. Por favor, verifica tu conexión e intenta nuevamente.";
              } else if (_context.t1.message) {
                errorMessage = "Error: ".concat(_context.t1.message);
              }

              setErrors([errorMessage]);
              setIsSubmitting(false);

            case 52:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 46], [33, 40]]);
    }));

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var age = calculateAge(formData.birthdate || "");
  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header",
    style: {
      padding: "8px 15px"
    }
  }, /*#__PURE__*/React.createElement("h4", {
    style: {
      margin: 0,
      fontSize: "16px"
    }
  }, /*#__PURE__*/React.createElement("b", null, isNew ? "Nuevo Ejecutivo" : "Editar Ejecutivo"))), /*#__PURE__*/React.createElement("div", {
    className: "card-body",
    style: {
      padding: "8px 12px"
    }
  }, errors.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger",
    style: {
      padding: "6px 10px",
      marginBottom: "8px",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      marginBottom: 0,
      paddingLeft: "20px"
    }
  }, errors.map(function (error, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, error);
  }))), successMessage && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-success",
    style: {
      padding: "6px 10px",
      marginBottom: "8px",
      fontSize: "12px"
    }
  }, successMessage), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement("style", null, "\n            .form-group {\n              margin-bottom: 4px;\n            }\n            .form-group label {\n              margin-bottom: 1px;\n              font-size: 12px;\n              font-weight: 500;\n            }\n            .form-control {\n              padding: 3px 6px;\n              font-size: 12px;\n              height: 28px;\n            }\n            select.form-control {\n              height: 28px;\n              padding: 3px 6px;\n            }\n            textarea.form-control {\n              min-height: 40px;\n              resize: vertical;\n              padding: 3px 6px;\n              font-size: 12px;\n            }\n            .help-block {\n              font-size: 9px;\n              margin-top: 0px !important;\n              line-height: 1.0;\n            }\n            .border-danger {\n              border-color: #dc3545 !important;\n            }\n            .password-toggle {\n              position: absolute;\n              right: 10px;\n              top: 50%;\n              transform: translateY(-50%);\n              background: none;\n              border: none;\n              cursor: pointer;\n              color: #666;\n              font-size: 14px;\n              padding: 0;\n              z-index: 10;\n            }\n            .password-toggle:hover {\n              color: #333;\n            }\n            .password-input-wrapper {\n              position: relative;\n            }\n            /* Estilos modernos para DatePicker */\n            .react-datepicker {\n              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n              border: none;\n              border-radius: 12px;\n              box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n              overflow: hidden;\n            }\n            .react-datepicker__header {\n              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n              border-bottom: none;\n              padding: 16px 12px 12px;\n            }\n            .react-datepicker__current-month {\n              color: white;\n              font-weight: 700;\n              font-size: 1rem;\n              letter-spacing: 0.5px;\n              margin-bottom: 8px;\n            }\n            .react-datepicker__day-names {\n              display: flex;\n              justify-content: space-around;\n              margin-top: 8px;\n            }\n            .react-datepicker__day-name {\n              color: rgba(255, 255, 255, 0.9);\n              font-weight: 600;\n              font-size: 0.75rem;\n              width: 36px;\n              line-height: 36px;\n              margin: 0;\n              text-transform: uppercase;\n              letter-spacing: 0.5px;\n            }\n            .react-datepicker__month {\n              margin: 12px;\n              background-color: white;\n            }\n            .react-datepicker__week {\n              display: flex;\n              justify-content: space-around;\n            }\n            .react-datepicker__day {\n              width: 36px;\n              height: 36px;\n              line-height: 36px;\n              margin: 2px;\n              border-radius: 8px;\n              font-weight: 500;\n              transition: all 0.2s ease;\n              color: #374151;\n            }\n            .react-datepicker__day:hover {\n              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n              color: white;\n              transform: scale(1.1);\n              border-radius: 8px;\n            }\n            .react-datepicker__day--selected,\n            .react-datepicker__day--keyboard-selected {\n              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n              color: white;\n              font-weight: 700;\n              border-radius: 8px;\n              box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);\n            }\n            .react-datepicker__day--today {\n              font-weight: 700;\n              background-color: #f3f4f6;\n              color: #667eea;\n              border: 2px solid #667eea;\n              border-radius: 8px;\n            }\n            .react-datepicker__day--outside-month {\n              color: #d1d5db;\n            }\n            .react-datepicker__day--disabled {\n              color: #e5e7eb;\n              cursor: not-allowed;\n            }\n            .react-datepicker__day--disabled:hover {\n              background: transparent;\n              transform: none;\n            }\n            .react-datepicker__navigation {\n              top: 16px;\n              width: 32px;\n              height: 32px;\n              border-radius: 8px;\n              background-color: rgba(255, 255, 255, 0.2);\n              transition: all 0.2s ease;\n            }\n            .react-datepicker__navigation:hover {\n              background-color: rgba(255, 255, 255, 0.3);\n            }\n            .react-datepicker__navigation-icon::before {\n              border-color: white;\n              border-width: 2px 2px 0 0;\n              top: 10px;\n            }\n            .react-datepicker__month-dropdown,\n            .react-datepicker__year-dropdown {\n              background-color: white;\n              border: 1px solid #e5e7eb;\n              border-radius: 8px;\n              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n              padding: 4px;\n              max-height: 200px;\n              overflow-y: auto;\n            }\n            .react-datepicker__month-option,\n            .react-datepicker__year-option {\n              padding: 8px 12px;\n              border-radius: 6px;\n              transition: all 0.2s ease;\n              cursor: pointer;\n            }\n            .react-datepicker__month-option:hover,\n            .react-datepicker__year-option:hover {\n              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n              color: white;\n            }\n            .react-datepicker__month-option--selected,\n            .react-datepicker__year-option--selected {\n              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n              color: white;\n              font-weight: 600;\n            }\n            .react-datepicker__triangle {\n              display: none;\n            }\n          "), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Nombre Completo"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: formData.full_name || "",
    onChange: function onChange(e) {
      return handleChange("full_name", e.target.value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "RUT"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: formData.rut || "",
    onChange: function onChange(e) {
      return handleChange("rut", e.target.value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Tipo de Contrato"), /*#__PURE__*/React.createElement("select", {
    className: "form-control",
    value: formData.contract_type || "",
    onChange: function onChange(e) {
      var newContractType = e.target.value; // Si cambia a "Indefinido", limpiar fecha fin

      if (newContractType === "Indefinido") {
        setFormData(_objectSpread(_objectSpread({}, formData), {}, {
          contract_type: newContractType,
          contract_end_date: null
        }));
      } else {
        handleChange("contract_type", newContractType);
      }
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione..."), CONTRACT_TYPES.map(function (type) {
    return /*#__PURE__*/React.createElement("option", {
      key: type.value,
      value: type.value
    }, type.label);
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Cargo"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: formData.position || "",
    onChange: function onChange(e) {
      return handleChange("position", e.target.value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Inicio Contrato"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd/MM/yyyy",
    selected: formData.contract_start_date ? moment(formData.contract_start_date).toDate() : null,
    onChange: function onChange(date) {
      return handleDateChange("contract_start_date", date);
    },
    placeholderText: "Seleccione fecha",
    showYearDropdown: true,
    showMonthDropdown: true,
    dropdownMode: "select",
    yearDropdownItemNumber: 50,
    scrollableYearDropdown: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Fin Contrato ", formData.contract_type === "Fijo" && /*#__PURE__*/React.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd/MM/yyyy",
    selected: formData.contract_end_date ? moment(formData.contract_end_date).toDate() : null,
    onChange: function onChange(date) {
      return handleDateChange("contract_end_date", date);
    },
    placeholderText: "Seleccione fecha",
    locale: "es",
    disabled: formData.contract_type === "Indefinido",
    minDate: formData.contract_start_date ? moment(formData.contract_start_date).toDate() : null,
    isClearable: formData.contract_type === "Honorarios",
    showYearDropdown: true,
    showMonthDropdown: true,
    dropdownMode: "select",
    yearDropdownItemNumber: 50,
    scrollableYearDropdown: true
  }), formData.contract_type === "Indefinido" && /*#__PURE__*/React.createElement("small", {
    className: "help-block",
    style: {
      color: "#666"
    }
  }, "Indefinido: no requiere fecha fin"), formData.contract_type === "Honorarios" && /*#__PURE__*/React.createElement("small", {
    className: "help-block",
    style: {
      color: "#666"
    }
  }, "Honorarios: fecha fin opcional"), formData.contract_type === "Fijo" && /*#__PURE__*/React.createElement("small", {
    className: "help-block",
    style: {
      color: "#666"
    }
  }, "Fijo: requiere fecha fin")))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Comisi\xF3n Vida"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: lifeCommissionInput,
    onChange: function onChange(e) {
      var value = e.target.value; // Permitir solo números, comas y puntos decimales

      if (value === "" || /^[\d,.]*$/.test(value)) {
        setLifeCommissionInput(value); // Convertir a número solo si es válido

        var normalizedValue = value.replace(",", ".");

        if (normalizedValue === "" || normalizedValue === "." || normalizedValue === ",") {
          handleChange("life_commission", null);
        } else {
          var numValue = parseFloat(normalizedValue);

          if (!isNaN(numValue)) {
            handleChange("life_commission", numValue);
          }
        }
      }
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Comisi\xF3n Generales (%)"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: generalCommissionInput,
    onChange: function onChange(e) {
      var value = e.target.value; // Permitir solo números, comas y puntos decimales

      if (value === "" || /^[\d,.]*$/.test(value)) {
        setGeneralCommissionInput(value); // Convertir a número solo si es válido

        var normalizedValue = value.replace(",", ".");

        if (normalizedValue === "" || normalizedValue === "." || normalizedValue === ",") {
          handleChange("general_commission_percentage", null);
        } else {
          var numValue = parseFloat(normalizedValue);

          if (!isNaN(numValue)) {
            handleChange("general_commission_percentage", numValue);
          }
        }
      }
    }
  }), /*#__PURE__*/React.createElement("small", {
    className: "help-block",
    style: {
      color: "#666",
      fontStyle: "italic"
    }
  }, "Se multiplica seg\xFAn categor\xEDa de compa\xF1\xEDa (GENERALES o VIDA)"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Comisi\xF3n Renovaci\xF3n"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: renewalCommissionInput,
    onChange: function onChange(e) {
      var value = e.target.value; // Permitir solo números, comas y puntos decimales

      if (value === "" || /^[\d,.]*$/.test(value)) {
        setRenewalCommissionInput(value); // Convertir a número solo si es válido

        var normalizedValue = value.replace(",", ".");

        if (normalizedValue === "" || normalizedValue === "." || normalizedValue === ",") {
          handleChange("renewal_commission", null);
        } else {
          var numValue = parseFloat(normalizedValue);

          if (!isNaN(numValue)) {
            handleChange("renewal_commission", numValue);
          }
        }
      }
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Fecha de Nacimiento"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd/MM/yyyy",
    selected: formData.birthdate ? moment(formData.birthdate).toDate() : null,
    onChange: function onChange(date) {
      return handleDateChange("birthdate", date);
    },
    maxDate: new Date(),
    placeholderText: "Seleccione fecha",
    showYearDropdown: true,
    showMonthDropdown: true,
    dropdownMode: "select",
    yearDropdownItemNumber: 100,
    scrollableYearDropdown: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Edad"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: ageInput,
    onChange: function onChange(e) {
      var value = e.target.value; // Permitir solo números

      if (value === "" || /^\d*$/.test(value)) {
        setAgeInput(value);
      }
    },
    placeholder: "Se calcula autom\xE1ticamente"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Tel\xE9fono"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: formData.phone || "",
    onChange: function onChange(e) {
      return handleChange("phone", e.target.value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Mail (Email) *"), /*#__PURE__*/React.createElement("input", {
    type: "email",
    className: "form-control",
    value: formData.email || "",
    onChange: function onChange(e) {
      return handleChange("email", e.target.value);
    },
    required: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, isNew ? "Contraseña *" : "Nueva Contraseña"), /*#__PURE__*/React.createElement("div", {
    className: "password-input-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    type: showPassword ? "text" : "password",
    className: "form-control",
    value: password,
    onChange: function onChange(e) {
      setPassword(e.target.value); // Limpiar error de contraseñas si se está corrigiendo

      if (errors.length > 0 && errors[0] === "Las contraseñas no coinciden") {
        setErrors([]);
      }
    },
    required: isNew,
    placeholder: !isNew ? "Dejar en blanco para no cambiar" : "",
    style: {
      paddingRight: "35px"
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "password-toggle",
    onClick: function onClick() {
      return setShowPassword(!showPassword);
    },
    title: showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
  }, showPassword ? "👁️" : "👁️‍🗨️")))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Confirmar Contrase\xF1a"), /*#__PURE__*/React.createElement("div", {
    className: "password-input-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    type: showPasswordConfirmation ? "text" : "password",
    className: "form-control ".concat(password && passwordConfirmation && password !== passwordConfirmation ? "border-danger" : ""),
    value: passwordConfirmation,
    onChange: function onChange(e) {
      setPasswordConfirmation(e.target.value); // Validar en tiempo real si las contraseñas coinciden

      if (password && e.target.value && password !== e.target.value) {
        setErrors(["Las contraseñas no coinciden"]);
      } else if (password && e.target.value && password === e.target.value) {
        // Limpiar error si ahora coinciden
        setErrors([]);
      }
    },
    required: isNew,
    style: {
      paddingRight: "35px"
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "password-toggle",
    onClick: function onClick() {
      return setShowPasswordConfirmation(!showPasswordConfirmation);
    },
    title: showPasswordConfirmation ? "Ocultar contraseña" : "Mostrar contraseña"
  }, showPasswordConfirmation ? "👁️" : "👁️‍🗨️")), password && passwordConfirmation && password !== passwordConfirmation && /*#__PURE__*/React.createElement("small", {
    className: "help-block",
    style: {
      color: "#dc3545",
      marginTop: "2px"
    }
  }, "Las contrase\xF1as no coinciden")))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", null, "Comentarios (Opcional)"), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    rows: 1,
    style: {
      padding: "3px 6px",
      fontSize: "12px",
      minHeight: "35px"
    },
    value: formData.comments || "",
    onChange: function onChange(e) {
      return handleChange("comments", e.target.value);
    },
    placeholder: "Ingrese comentarios adicionales sobre el ejecutivo..."
  })))), /*#__PURE__*/React.createElement("div", {
    className: "form-actions",
    style: {
      marginTop: "6px",
      marginBottom: "0"
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary",
    disabled: isSubmitting,
    style: {
      padding: "4px 12px",
      fontSize: "12px"
    }
  }, isSubmitting ? "Guardando..." : "Guardar"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-info",
    onClick: handleClearForm,
    style: {
      marginLeft: "8px",
      padding: "4px 12px",
      fontSize: "12px"
    }
  }, "Limpiar Campos"), /*#__PURE__*/React.createElement("a", {
    href: "/admin/administrators",
    className: "btn btn-default",
    style: {
      marginLeft: "8px",
      padding: "4px 12px",
      fontSize: "12px",
      backgroundColor: "#6c757d",
      borderColor: "#6c757d",
      color: "#fff"
    }
  }, "Cancelar")))));
};

export default UserForm;